import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../../hooks/useSEO';

export default function KaohsiungPage() {
  useSEO({
    title: '高雄搬家公司推薦｜專業搬家服務｜高雄市搬家費用估價',
    description: '高雄搬家公司推薦！提供前鎮區、小港區、三民區、左營區、鼓山區等38區專業搬家服務。24小時服務、免費估價、專業團隊，高雄搬家首選。立即預約搬家服務！',
    keywords: '高雄搬家,高雄搬家公司,前鎮區搬家,小港區搬家,三民區搬家,左營區搬家,鼓山區搬家,高雄市搬家費用,高雄搬家推薦,高雄搬家估價',
    ogImage: 'https://public.readdy.ai/ai/img_res/45fa2cc62e111d268934b09281255ccb.jpg'
  });

  useEffect(() => {
    // Schema.org LocalBusiness 結構化資料
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      "name": "安心搬家 - 高雄搬家服務",
      "image": "https://readdy.ai/api/search-image?query=professional%20moving%20service%20team%20carefully%20loading%20furniture%20and%20boxes%20into%20truck%20in%20Kaohsiung%20city%20Taiwan%2C%20modern%20urban%20residential%20area%20background%2C%20bright%20daylight%2C%20workers%20wearing%20safety%20equipment%20and%20uniforms%2C%20organized%20and%20efficient%20moving%20process%2C%20high%20quality%20service%20scene&width=1200&height=630&seq=kaohsiung-moving-schema&orientation=landscape",
      "@id": "https://readdy.ai/area/kaohsiung",
      "url": "https://readdy.ai/area/kaohsiung",
      "telephone": "+886-800-888-888",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "高雄市前鎮區",
        "addressLocality": "高雄市",
        "postalCode": "806",
        "addressCountry": "TW"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": 22.6273,
        "longitude": 120.3014
      },
      "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday"
        ],
        "opens": "00:00",
        "closes": "23:59"
      },
      "areaServed": [
        { "@type": "City", "name": "新興區" },
        { "@type": "City", "name": "前金區" },
        { "@type": "City", "name": "苓雅區" },
        { "@type": "City", "name": "鹽埕區" },
        { "@type": "City", "name": "鼓山區" },
        { "@type": "City", "name": "旗津區" },
        { "@type": "City", "name": "前鎮區" },
        { "@type": "City", "name": "三民區" },
        { "@type": "City", "name": "楠梓區" },
        { "@type": "City", "name": "小港區" },
        { "@type": "City", "name": "左營區" },
        { "@type": "City", "name": "仁武區" },
        { "@type": "City", "name": "大社區" },
        { "@type": "City", "name": "東沙群島" },
        { "@type": "City", "name": "南沙群島" },
        { "@type": "City", "name": "岡山區" },
        { "@type": "City", "name": "路竹區" },
        { "@type": "City", "name": "阿蓮區" },
        { "@type": "City", "name": "田寮區" },
        { "@type": "City", "name": "燕巢區" },
        { "@type": "City", "name": "橋頭區" },
        { "@type": "City", "name": "梓官區" },
        { "@type": "City", "name": "彌陀區" },
        { "@type": "City", "name": "永安區" },
        { "@type": "City", "name": "湖內區" },
        { "@type": "City", "name": "鳳山區" },
        { "@type": "City", "name": "大寮區" },
        { "@type": "City", "name": "林園區" },
        { "@type": "City", "name": "鳥松區" },
        { "@type": "City", "name": "大樹區" },
        { "@type": "City", "name": "旗山區" },
        { "@type": "City", "name": "美濃區" },
        { "@type": "City", "name": "六龜區" },
        { "@type": "City", "name": "內門區" },
        { "@type": "City", "name": "杉林區" },
        { "@type": "City", "name": "甲仙區" },
        { "@type": "City", "name": "桃源區" },
        { "@type": "City", "name": "那瑪夏區" },
        { "@type": "City", "name": "茂林區" },
        { "@type": "City", "name": "茄萣區" }
      ],
      "priceRange": "$$",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "203"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const kaohsiungDistricts = [
    { name: '前鎮區', features: ['高雄港', '夢時代', '前鎮漁港'] },
    { name: '小港區', features: ['高雄國際機場', '臨海工業區', '小港醫院'] },
    { name: '三民區', features: ['高雄車站', '建工路', '覆鼎金'] },
    { name: '苓雅區', features: ['文化中心', '五福商圈', '青年路'] },
    { name: '新興區', features: ['中央公園', '六合夜市', '新堀江'] },
    { name: '左營區', features: ['高鐵左營站', '蓮池潭', '巨蛋商圈'] },
    { name: '楠梓區', features: ['楠梓加工區', '高雄大學', '都會公園'] },
    { name: '鳳山區', features: ['鳳山車站', '大東文化藝術中心', '衛武營'] },
    { name: '岡山區', features: ['岡山車站', '空軍官校', '皮影戲館'] },
    { name: '旗山區', features: ['旗山老街', '香蕉文化館', '旗山車站'] },
    { name: '美濃區', features: ['美濃民俗村', '客家文物館', '黃蝶翠谷'] },
    { name: '六龜區', features: ['六龜溫泉', '茂林國家風景區', '不老溫泉'] }
  ];

  const services = [
    {
      icon: 'ri-ship-line',
      title: '港區倉儲搬遷',
      description: '高雄港區貨櫃、倉儲設備專業搬運'
    },
    {
      icon: 'ri-building-4-line',
      title: '工業設備搬遷',
      description: '重工業機械、精密設備搬運認證'
    },
    {
      icon: 'ri-subway-line',
      title: '捷運沿線搬家',
      description: '紅橘兩線捷運站周邊便利搬家'
    },
    {
      icon: 'ri-plane-line',
      title: '機場周邊搬遷',
      description: '小港機場、航空城區域搬家服務'
    }
  ];

  const faqData = [
    {
      question: '高雄搬家公司推薦哪一家？',
      answer: '建鈞精緻搬家深耕高雄 38 區搬家服務，熟悉港區作業、工業區環境、捷運沿線交通。我們專精重工業設備、港口倉儲、高樓住宅、商辦大樓搬遷服務，擁有 4.8 分高評價，是高雄港都居民推薦的搬家公司。'
    },
    {
      question: '高雄搬家費用怎麼算？',
      answer: '高雄地區搬家費用：套房搬遷 3,000 元起（雙邊電梯優惠價），家庭搬遷 3,000-8,000 元，辦公室搬遷 5,000-20,000 元。港區倉儲、工業設備搬遷需現場評估。我們提供 24 小時服務，配合工業區輪班制度。'
    },
    {
      question: '高雄搬家當天可以預約嗎？',
      answer: '建議提前 3-7 天預約。港區、工業區搬遷因涉及重型設備和特殊作業環境，建議提前 1-2 週預約。我們提供 24 小時服務，配合工業區輪班時間。急件可來電 0978-900-081 詢問。'
    },
    {
      question: '高雄港區搬家要注意什麼？',
      answer: '港區搬家需注意：1. 遵守港區管制規定；2. 貨櫃倉儲需專業吊車設備；3. 配合港區作業時間；4. 重型設備需專業認證人員。我們深度瞭解高雄港區作業規範，貨櫃倉儲搬遷經驗豐富，確保安全順利。'
    },
    {
      question: '高雄工業區搬遷怎麼處理？',
      answer: '我們提供工業區專業搬遷服務：1. 擁有大型機械搬運設備；2. 重工業機具搬遷專業認證；3. 配合工業區輪班制度（24 小時服務）；4. 精密設備防震包裝。熟悉臨海工業區、楠梓加工區等環境，確保設備安全。'
    },
    {
      question: '高雄搬家什麼時間最便宜？',
      answer: '平日（週一至週五）和非月底時段價格較優惠。工業區搬遷可選擇夜間時段（配合輪班），避開白天作業高峰。我們提供 24 小時服務，彈性配合您的時間需求，歡迎來電詢問優惠方案。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[500px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Kaohsiung%20harbor%20city%20landscape%20with%20port%20facilities%20and%20industrial%20areas%2C%20modern%20urban%20skyline%20with%20organized%20residential%20neighborhoods%20and%20transportation%20infrastructure%2C%20professional%20moving%20services%20concept&width=1920&height=500&seq=kaohsiung001&orientation=landscape"
            alt="高雄搬家服務"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">高雄搬家公司推薦</h1>
          <p className="text-xl mb-8 leading-relaxed">
            深耕高雄38區搬家服務，熟悉港區作業、工業區環境、捷運沿線交通<br />
            專精重工業設備、港口倉儲、高樓住宅、商辦大樓搬遷服務
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081" 
              className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              立即致電：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>

      {/* Service Areas */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">高雄市 38 區完整服務</h2>
            <p className="text-xl text-gray-600">熟悉高雄各區域產業特色，提供在地化專業搬家服務</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {kaohsiungDistricts.map((district, index) => (
              <div key={index} className="bg-gradient-to-br from-teal-50 to-white border border-teal-200 rounded-xl p-6 hover:shadow-lg transition-shadow">
                <h3 className="font-bold text-lg text-gray-900 mb-3 flex items-center">
                  <i className="ri-map-2-line text-teal-600 mr-2"></i>
                  {district.name}
                </h3>
                <div className="space-y-1">
                  {district.features.map((feature, idx) => (
                    <div key={idx} className="text-sm text-gray-600 flex items-center">
                      <i className="ri-checkbox-circle-line text-teal-500 mr-2 text-xs"></i>
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Specialized Services */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">高雄港都特色服務</h2>
            <p className="text-xl text-gray-600">針對高雄工業港都特色，提供專業搬遷解決方案</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
                <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Industrial Advantages */}
      <section className="py-20 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">工業港都搬遷優勢</h2>
            <p className="text-xl text-gray-600">專精高雄工業環境，提供最專業的重工業搬遷服務</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-anchor-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">港區作業熟悉</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                深度瞭解高雄港區作業規範，貨櫃倉儲搬遷經驗豐富
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-settings-4-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">重工業設備</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                擁有大型機械搬運設備，重工業機具搬遷專業認證
              </p>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-white rounded-xl p-6 border border-emerald-100">
              <div className="w-12 h-12 bg-emerald-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-train-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">捷運交通便利</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                熟悉紅橘兩線捷運路網，提供捷運沿線便利搬家服務
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-white rounded-xl p-6 border border-green-100">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-building-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">高層建築經驗</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                85 大樓、夢時代等高層建築搬遷經驗，電梯搬運專業
              </p>
            </div>

            <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-6 border border-teal-100">
              <div className="w-12 h-12 bg-teal-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-plane-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">機場周邊服務</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                小港機場航空城區域搬家，國際物流轉運配合
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-white rounded-xl p-6 border border-cyan-100">
              <div className="w-12 h-12 bg-cyan-500 rounded-lg flex items-center justify-center mb-4">
                <i className="ri-24-hours-line text-xl text-white"></i>
              </div>
              <h3 className="font-bold text-lg text-gray-900 mb-3">24小時服務</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                配合工業區輪班制度，提供 24 小時搬家服務
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 高雄搬家常見問題（口語化） */}
      <section className="py-20 px-4 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">高雄搬家常見問題</h2>
            <p className="text-xl text-gray-600">最多人問的高雄港都搬家問題，一次解答</p>
          </div>

          <div className="space-y-6">
            {faqData.map((faq, index) => (
              <div key={index} className="bg-white p-8 rounded-xl border border-gray-200 hover:shadow-lg transition-shadow">
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                  <i className="ri-question-line text-teal-500"></i>
                  {faq.question}
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            ))}
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/faq" 
              className="inline-block bg-teal-500 hover:bg-teal-600 text-white px-8 py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              查看更多常見問題
            </Link>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-500 to-teal-600">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h2 className="text-4xl font-bold mb-6">準備在高雄搬家嗎？</h2>
          <p className="text-xl mb-8 leading-relaxed">
            立即聯繫我們，獲得專業的高雄港都搬家服務評估<br />
            24 小時服務，配合工業區輪班制度
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="tel:0978900081"
              className="bg-white hover:bg-gray-100 text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              電話諮詢：0978-900-081
            </a>
            <a 
              href="https://line.me/ti/p/@285yavdh" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-teal-700 hover:bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
            >
              <i className="ri-line-fill mr-2"></i>
              官方LINE
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}
